import { Link } from 'react-router-dom';
import { ArrowUpRight, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface LinkChip {
  to: string;
  label: string;
  icon?: LucideIcon;
}

export function LinkChips({ links, className }: { links: readonly LinkChip[]; className?: string }) {
  if (links.length === 0) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {links.map((link) => {
        const Icon = link.icon ?? ArrowUpRight;
        return (
          <Link
            key={`${link.to}|${link.label}`}
            to={link.to}
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border bg-card px-2.5 py-0.5 text-xs font-medium text-foreground transition-colors hover:bg-accent focus-ring"
          >
            <Icon className={cn('h-3 w-3 text-muted-foreground', !link.icon && 'rtl:-scale-x-100')} aria-hidden="true" />
            {link.label}
          </Link>
        );
      })}
    </div>
  );
}
